export default __webpack_public_path__ + "static/media/MOBILEPOP.280f8361.png";